export const integrationsVoucherGroupIdAppGroupIdVoucherGroupReferences =
  "/integrations/voucher_group/:id/:app_group_id/voucher_group_references";
